import { defineRegleNuxtPlugin } from '@regle/nuxt/setup'
import { defineRegleConfig } from '@regle/core'

import {
  between,
  checked,
  decimal,
  email,
  integer,
  maxLength,
  maxValue,
  minLength,
  minValue,
  oneOf,
  required,
  sameAs,
  url,
  withMessage,
} from '@regle/rules'

export default defineRegleNuxtPlugin(() => defineRegleConfig({
  rules: () => {
    const { t } = useI18n({
      useScope: 'global',
    })

    return {
      // Presence
      required: withMessage(required, () => t('errors.rules.required')),
      checked: withMessage(checked, () => t('errors.rules.checked')),

      // Text length
      minLength: withMessage(minLength, ({ $params: [length] }) => t('errors.rules.minLength', { length })),
      maxLength: withMessage(maxLength, ({ $params: [length] }) => t('errors.rules.maxLength', { length })),

      // Numbers
      between: withMessage(between, ({ $params: [min, max] }) => t('errors.rules.between', { min, max })),
      minValue: withMessage(minValue, ({ $params: [min] }) => t('errors.rules.minValue', { min })),
      maxValue: withMessage(maxValue, ({ $params: [max] }) => t('errors.rules.maxValue', { max })),
      integer: withMessage(integer, () => t('errors.rules.integer')),
      decimal: withMessage(decimal, () => t('errors.rules.decimal')),

      // Contact
      email: withMessage(email, () => t('errors.rules.email')),
      isEmailAvailable: withMessage(isEmailAvailable, () => t('errors.rules.isEmailAvailable')),
      phoneValid: withMessage(phoneValid, () => t('errors.rules.phoneValid')),
      phoneDifferent: withMessage(phoneDifferent, () => t('errors.rules.phoneDifferent')),

      // Address
      address: withMessage(address, () => t('errors.rules.address')),
      addressSelected: withMessage(addressSelected, () => t('errors.rules.addressSelected')),
      postalCode: withMessage(postalCode, () => t('errors.rules.postalCode')),

      // Password
      passwordCasing: withMessage(passwordCasing, () => t('errors.rules.passwordCasing')),
      passwordNumberOrSymbol: withMessage(passwordNumberOrSymbol, () => t('errors.rules.passwordNumberOrSymbol')),
      passwordMatch: withMessage(sameAs, () => t('errors.rules.passwordMatch')),

      // Choice and time
      oneOf: withMessage(oneOf, () => t('errors.rules.oneOf')),
      sameAs: withMessage(sameAs, () => t('errors.rules.sameAs')),
      timeBefore: withMessage(timeBefore, () => t('errors.rules.timeBefore')),
      timeAfter: withMessage(timeAfter, () => t('errors.rules.timeAfter')),

      // URL
      url: withMessage(url, () => t('errors.rules.url')),
      matterportUrl: withMessage(matterportUrl, () => t('errors.rules.matterportUrl')),

      // ID
      driverLicense: withMessage(driverLicense, () => t('errors.rules.driverLicense')),
    }
  },
  shortcuts: {
    fields: { $firstError: (field) => field.$errors[0] },
  },
  modifiers: { autoDirty: false },
}))
